import project1_img from '../assets/project_1.jpg'
import project2_img from '../assets/project_2.jpg'
import project3_img from '../assets/project_3.png'
import project4_img from '../assets/project_4.jpg'
// import project5_img from '../assets/project_5.svg'
// import project6_img from '../assets/project_6.svg'

const mywork_data = [
    {
        w_no:1,
        name:"Tic Tac Toe Game",
        w_img:project1_img,
        link: "https://tic-tac-toe-txvo.onrender.com/"
    },
    {
        w_no:2,
        name:"Government Budget Transparency Portal",
        w_img:project2_img,
        link: "https://govbudget-frontend.onrender.com/"
    },
    {
        w_no:3,
        name:"Split the Bill",
        w_img:project3_img,
        link: "https://splitthebill-raum.onrender.com/"
    },
    {
        w_no:4,
        name:"SoccerKart",
        w_img:project4_img,
        link: "https://soccerkart.onrender.com/"
    },
    // {
    //     w_no:5,
    //     w_name:"Web design",
    //     w_img:project5_img
    // },
    // {
    //     w_no:6,
    //     w_name:"Web design",
    //     w_img:project6_img
    // },
]
 
export default mywork_data;